import {combineReducers} from "redux";
import {project, projects} from "reducers/project";
import {operators, me} from "reducers/user";
import {login} from "reducers/login";
import {addresses} from "reducers/address";
import {winners} from "reducers/winner";
import {loadingCount} from "reducers/loading";
import {form, forms} from "reducers/form";
import {faq} from "reducers/faq";
import {contact} from "reducers/contact";
import {register} from "reducers/register";
import {error} from "reducers/error";
import {popup} from "reducers/popup";
import {serialCode, serialCodes} from "reducers/serialCode";
import {serialCodeData} from "reducers/serialCodeData";
import {survey, surveys} from "reducers/survey"
import {refund} from "reducers/refund"

const shippingApp = combineReducers({
    project,
    projects,
    operators,
    me,
    login,
    addresses,
    winners,
    loadingCount,
    form,
    forms,
    faq,
    contact,
    register,
    error,
    popup,
    serialCode,
    serialCodes,
    serialCodeData,
    survey,
    surveys,
    refund
});

export default shippingApp
